import { Modal } from '@trackman/web-shared-components';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { auth } from 'stores/AuthorizationStore';

type Props = {
  logoutUrl: string;
};

const LoggedOutInfoModal = observer(({ logoutUrl }: Props) => {
  return (
    <Modal
      title={'LoggedOut'}
      open={auth.isLoggedOutModalOn}
      onClose={() => auth.setIsLoggedOutModalOn(false)}
      confirmBtn={{ label: 'Go to login page', onClick: () => window.location.assign(logoutUrl) }}
      cancelBtn={{ label: 'Stay on this page', onClick: () => auth.setIsLoggedOutModalOn(false) }}
      style={{ zIndex: 2001 }}
    >
      <div style={{ padding: '30px' }}>
        <p>You have been logged out.</p>
        <p>You can close this modal and stay on this page to save progress, but any interactions with the page will fail.</p>
        <p>If you want to continue using the app, please log in again.</p>
      </div>
    </Modal>
  );
});
export default LoggedOutInfoModal;
